import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { Box, Typography } from "@mui/material";
import type { DateTime } from "luxon";
import { INK, NEUTRAL } from "../../theme/tokens";
import { getShiftDisplayDate } from "../../utils/dateUtils";

interface IProps {
	startTime: DateTime;
	endTime: DateTime;
	dayStart: string;
	/** Department `shift_delta_minutes`, so the label shows the day the shift is actually stored on. */
	graceMinutes?: number;
}

export const DateRangleLabel = ({ startTime, endTime, dayStart, graceMinutes }: IProps) => {
	return (
		<Box
			sx={{
				backgroundColor: NEUTRAL[150],
				color: INK.SECONDARY,
				display: "flex",
				padding: "0 10px",
				width: "fit-content",
				height: "24px",
				alignItems: "center",
				justifyContent: "center",
				gap: 1,
				borderRadius: "4px",
			}}
		>
			<CalendarMonthIcon fontSize="small" sx={(theme) => ({ width: "16px", height: "16px", color: theme.palette.primary.main })} />
			<Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
				{getShiftDisplayDate(startTime, dayStart, graceMinutes).toFormat("ccc, MMM d")} {startTime.toFormat("h:mm a")} - {endTime.toFormat("h:mm a")}
			</Typography>
		</Box>
	);
};
